/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import { asideMenuFlag, reviewscreenFlag, commonConstants, winscpOtpFlags } from '../constants';
const asideFlag = false;
const winscpOtp = false;
const isReviewScreen = false;
const isDashboard = false;
const isRiskAnalysis = false;

const initialCPA = {};

function displayWinscpOtp(state = winscpOtp, action) {
  if (action?.type == winscpOtpFlags.DISPLAY_WINSCP_OTP) {
    return true;
  } else if (action?.type == winscpOtpFlags.HIDE_WINSCP_OTP) {
    return false;
  } else {
    return state;
  }
}

function selectedCPA(action, state = initialCPA) {
  if (action?.type === commonConstants.SET_CPA) {
    return action?.payload;
  } else {
    return state;
  }
}

function aSideMenuFlag(action, state = asideFlag) {
  if (action?.type === asideMenuFlag.ASIDE_MENU_OPEN) {
    return true;
  } else if (action?.type === asideMenuFlag.ASIDE_MENU_CLOSE) {
    return false;
  } else {
    return state;
  }
}

function reviewScreenFlag(action, state = isReviewScreen) {
  if (action?.type === reviewscreenFlag.REVIEW_SCREEN_OPEN) {
    return true;
  } else if (action?.type === reviewscreenFlag.REVIEW_SCREEN_CLOSE) {
    return false;
  } else {
    return state;
  }
}

function isDashboardOn(action, state = isDashboard) {
  if (action?.type === commonConstants.IS_DASHBOARD_ON) {
    return true;
  } else if (action?.type === commonConstants.IS_DASHBOARD_OFF) {
    return false;
  } else {
    return state;
  }
}

function isRiskAnalysisTab(action, state = isRiskAnalysis) {
  if (action?.type === commonConstants.IS_RISK_ANALYSIS_TAB_ACTIVE) {
    return true;
  } else if (action?.type === commonConstants.IS_RISK_ANALYSIS_TAB_INACTIVE) {
    return false;
  } else {
    return state;
  }
}

export {
  aSideMenuFlag,
  reviewScreenFlag,
  isDashboardOn,
  isRiskAnalysisTab,
  selectedCPA,
  displayWinscpOtp,
};
